<template>
  <v-carousel
    class="v-carousel-slide"
    v-model="model"
    :cycle="false"
    hide-delimiters
    :show-arrows="false"
    :touch="touch"
    height="100%"
    continuous
  >
    <v-carousel-item v-for="(banner, index) in banners" :key="index" :style="{ cursor: banner.linkUrl ? 'pointer' : '' }">
      <v-sheet height="100%" tile>
        <v-img :src="banner.imgBasedOnLang" style="height:100%;"></v-img>
      </v-sheet>
      <div class="banner-content-wrapper" @click="navigateTo(banner.linkUrl)"></div>
    </v-carousel-item>

    <div class="btn-class">
      <v-btn class="btn btn-previous" @click="previousSlide">
        <img :src="require('@/assets/images/home/arrow_left_w.png')" alt="" />
      </v-btn>
      <v-btn class="btn btn-next" @click="nextSlide">
        <img :src="require('@/assets/images/home/arrow_right_w.png')" alt="" />
      </v-btn>
    </div>
  </v-carousel>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    banners: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      model: 0,
      touch: {
        left: () => this.nextSlide(),
        right: () => this.previousSlide()
      }
    };
  },
  computed: {
    ...mapGetters(['Getter_Token'])
  },
  methods: {
    navigateTo(pageName) {
      if (pageName && pageName.includes('https')) {
        window.open(pageName, '_blank');
        return;
      }
      if (!this.Getter_Token) {
        if (!pageName) {
          return;
        }
        this.$router.push({ name: pageName });
      }
    },
    previousSlide() {
      this.model--;
      if (this.model < 0) {
        this.model = this.banners.length - 1;
      }
    },
    nextSlide() {
      this.model++;
    }
  },
  mounted() {}
};
</script>

<style lang="stylus" scoped>
.v-carousel-slide {
  padding: 0px;
}

.banner-content-wrapper {
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: absolute;
  top: 0;
  z-index: 1;
}

.cursor-pointer {
  cursor: pointer;
}

.btn-class {
  position: absolute;
  margin: 18px;
  bottom: 0;
  right: 0;
  z-index: 1;
  .btn {
    min-width: 44px;
    max-width: 44px !important;
    height: 44px;
    color: #fff;
    background-color: rgba(26, 31, 51, 0.9) !important;
    margin-right: 10px;
  }
}
</style>
